import { defineStore } from 'pinia';
import { aiModelsAndLabelsApiService } from 'src/services';
import type { dynamicObj } from 'src/pages/assets';

export const useCustomModelLabelsDropdownStore = defineStore(
  'custom_model_labels_dropdown',
  {
    state: () => ({
      label_categories: {} as dynamicObj,
      custom_model_labels: [] as any,
      custom_model_labels_list: [] as any,
      custom_model_labels_loading: false,
    }),
    actions: {
      async getModelLabels(model_name = '') {
        try {
          this.custom_model_labels_loading = true;
          this.custom_model_labels = [];

          const response =
            await aiModelsAndLabelsApiService.getModelLabels(model_name);

          if (!response) {
            throw response;
          }

          this.custom_model_labels = response;
          this.prepareDropdown();
        } catch (err) {
          logError(err);
        } finally {
          this.custom_model_labels_loading = false;
        }
      },

      prepareDropdown() {
        this.custom_model_labels.forEach((item: any, index: any) => {
          if (!this.label_categories.hasOwnProperty(item.label_category)) {
            this.label_categories[item.label_category] = {};
          }

          this.label_categories[item.label_category][item.id] = {};
          this.label_categories[item.label_category][item.id] = item;
        });

        const ordered = Object.keys(this.label_categories)
          .sort()
          .reduce((obj: dynamicObj, key) => {
            obj[key] = this.label_categories[key];
            return obj;
          }, {});
        this.label_categories = ordered;

        this.custom_model_labels_list = [];
        for (const [category_name, category] of Object.entries(
          this.label_categories,
        )) {
          const category_data = category as dynamicObj;

          this.custom_model_labels_list.push(
            Object.assign(
              {},
              { value: category_name, label: category_name, has_child: true },
            ),
          );
          for (const [index, item] of Object.entries(category_data)) {
            this.custom_model_labels_list.push(
              Object.assign({}, { value: item.id, label: item.label_name }),
            );
          }
        }
      },
    },
  },
);
